import { useEffect, useRef } from "react";

/**
 * שימוש:
 * const sentinelRef = useInfiniteScroll(() => setPage(p=>p+1), {
 *   enabled: !loading && hasMore,
 *   root: null,            // window
 *   rootMargin: "0px 0px 200px 0px", // תטען 200px לפני הסוף
 *   threshold: 0           // ברירת-מחדל
 * });
 */
export default function useInfiniteScroll(
  onLoadMore,
  {
    enabled     = true,
    root        = null,
    rootMargin  = "0px",
    threshold   = 0,
  } = {}
) {
  const sentinelRef   = useRef(null);
  const callbackRef   = useRef(onLoadMore);

  /* שמור את הפונקציה האחרונה כדי לא לפרק כל פעם את ה-observer */
  useEffect(() => { callbackRef.current = onLoadMore; }, [onLoadMore]);

  useEffect(() => {
    if (!enabled) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) callbackRef.current();
      },
      { root, rootMargin, threshold }
    );

    const el = sentinelRef.current;
    if (el) observer.observe(el);

    return () => { if (el) observer.unobserve(el); };
  }, [enabled, root, rootMargin, threshold]);

  return sentinelRef;
}
